const administracionDeContenidos = {
    ObtenerContenidosDeIntranetAdministracion: 'SICPO/Intranet/Administracion/Contenidos/ObtenerContenidosDeIntranet',
    GuardarContenidoDeIntranetAdministracion: 'SICPO/Intranet/Administracion/Contenidos/GuardarContenido',
    CambioDeEstatusContenidosDeIntranetAdministracion: 'SICPO/Intranet/Administracion/Contenidos/CambioDeEstatus',
    ObtenerCamposDeFormulario: 'SICPO/Intranet/Administracion/Contenidos/ObtenerCamposDeFormulario',
    ModificarOrdenamientoContenidosDeIntranetAdministracion: 'SICPO/Intranet/Administracion/Contenidos/ModificarOrdenamientoContenidosIntranet',
    OrdenamientoAlfabeticoContenidosDeIntranetAdministracion: 'SICPO/Intranet/Administracion/Contenidos/OrdenamientoAlfabeticoContenidosDeIntranet'
}

export default administracionDeContenidos;


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SICPO/sistema/intranet/administracionDeContenidos/administracionDeContenidos.js
// module id = null
// module chunks = 